import type { Edge, EdgeProps } from '@xyflow/react';
import { BaseEdge, getSmoothStepPath } from '@xyflow/react';
import type { FunctionComponent } from 'react';
import type { FamilyTreeEdgeData } from '../interfaces';

type FamilyTreeEdgeType = Edge<FamilyTreeEdgeData, 'familyTreeEdge'>;

export const FamilyTreeEdge: FunctionComponent<EdgeProps<FamilyTreeEdgeType>> = ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
}) => {
    const [edgePath] = getSmoothStepPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });

    return <BaseEdge id={id} path={edgePath} />;
};
